import PopupResultFormComponent from '../../form/js/popup-result-form.component';
import template from '../html/sucess-template.hbs';

export default class ResetPasswordFormComponent extends PopupResultFormComponent {
    getTemplate() {
        return template;
    }
}



// WEBPACK FOOTER //
// ./app/components/reset-password-form/js/reset-password-form.component.js